import { useState, useEffect } from "react";

/**
 * Custom hook to track scroll position and calculate a normalized value (0-1)
 * @param maxScroll - The scroll position at which the effect reaches maximum (default: 100)
 * @returns A value between 0 and 1 representing the scroll progress
 */
export const useScrollEffect = (maxScroll = 100) => {
  const [scrollAlpha, setScrollAlpha] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const y = window.scrollY;
      const percent = Math.min(y / maxScroll, 1);
      setScrollAlpha(percent);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [maxScroll]);

  return scrollAlpha;
};
